__turbopack_context__.v({
  "abilities": "sheet-module__aNwnPa__abilities",
  "ability": "sheet-module__aNwnPa__ability",
  "abilityModifier": "sheet-module__aNwnPa__abilityModifier",
  "abilityName": "sheet-module__aNwnPa__abilityName",
  "abilityRow": "sheet-module__aNwnPa__abilityRow",
  "abilityRowBonus": "sheet-module__aNwnPa__abilityRowBonus",
  "abilityRowName": "sheet-module__aNwnPa__abilityRowName",
  "abilityRows": "sheet-module__aNwnPa__abilityRows",
  "abilitySave": "sheet-module__aNwnPa__abilitySave",
  "abilityScore": "sheet-module__aNwnPa__abilityScore",
  "abilityValues": "sheet-module__aNwnPa__abilityValues",
  "actionTable": "sheet-module__aNwnPa__actionTable",
  "actionsTable": "sheet-module__aNwnPa__actionsTable",
  "activeSpell": "sheet-module__aNwnPa__activeSpell",
  "armorClassTable": "sheet-module__aNwnPa__armorClassTable",
  "armorClassValue": "sheet-module__aNwnPa__armorClassValue",
  "attentionText": "sheet-module__aNwnPa__attentionText",
  "attuned": "sheet-module__aNwnPa__attuned",
  "attunement": "sheet-module__aNwnPa__attunement",
  "baseItemMenu": "sheet-module__aNwnPa__baseItemMenu",
  "baseSelect": "sheet-module__aNwnPa__baseSelect",
  "block": "sheet-module__aNwnPa__block",
  "blockTitle": "sheet-module__aNwnPa__blockTitle",
  "bottomNav": "sheet-module__aNwnPa__bottomNav",
  "bottomNavActive": "sheet-module__aNwnPa__bottomNavActive",
  "bottomNavButton": "sheet-module__aNwnPa__bottomNavButton",
  "bottomNavIcon": "sheet-module__aNwnPa__bottomNavIcon",
  "bottomNavMenu": "sheet-module__aNwnPa__bottomNavMenu",
  "bottomNavMenuItem": "sheet-module__aNwnPa__bottomNavMenuItem",
  "bottomNavMore": "sheet-module__aNwnPa__bottomNavMore",
  "castButton": "sheet-module__aNwnPa__castButton",
  "castFull": "sheet-module__aNwnPa__castFull",
  "castShort": "sheet-module__aNwnPa__castShort",
  "cellButtons": "sheet-module__aNwnPa__cellButtons",
  "cellNote": "sheet-module__aNwnPa__cellNote",
  "checkCell": "sheet-module__aNwnPa__checkCell",
  "chipCount": "sheet-module__aNwnPa__chipCount",
  "coinCount": "sheet-module__aNwnPa__coinCount",
  "coinInput": "sheet-module__aNwnPa__coinInput",
  "coinInputs": "sheet-module__aNwnPa__coinInputs",
  "coinRow": "sheet-module__aNwnPa__coinRow",
  "coinTitle": "sheet-module__aNwnPa__coinTitle",
  "coinsPlate": "sheet-module__aNwnPa__coinsPlate",
  "coinsTotal": "sheet-module__aNwnPa__coinsTotal",
  "columns": "sheet-module__aNwnPa__columns",
  "condition": "sheet-module__aNwnPa__condition",
  "conditionActive": "sheet-module__aNwnPa__conditionActive",
  "conditionEffects": "sheet-module__aNwnPa__conditionEffects",
  "conditions": "sheet-module__aNwnPa__conditions",
  "damageLabel": "sheet-module__aNwnPa__damageLabel",
  "damageTypeIcon": "sheet-module__aNwnPa__damageTypeIcon",
  "deathSaveMarks": "sheet-module__aNwnPa__deathSaveMarks",
  "deathSaveMarksSmall": "sheet-module__aNwnPa__deathSaveMarksSmall",
  "deathSaves": "sheet-module__aNwnPa__deathSaves",
  "deathSavesPanel": "sheet-module__aNwnPa__deathSavesPanel",
  "deathSavesTitle": "sheet-module__aNwnPa__deathSavesTitle",
  "descriptionCell": "sheet-module__aNwnPa__descriptionCell",
  "dollArmorLabel": "sheet-module__aNwnPa__dollArmorLabel",
  "dollBody": "sheet-module__aNwnPa__dollBody",
  "dollColumn": "sheet-module__aNwnPa__dollColumn",
  "dollFigure": "sheet-module__aNwnPa__dollFigure",
  "dollLabel": "sheet-module__aNwnPa__dollLabel",
  "dollList": "sheet-module__aNwnPa__dollList",
  "dollShieldLabel": "sheet-module__aNwnPa__dollShieldLabel",
  "dollSvg": "sheet-module__aNwnPa__dollSvg",
  "dollWorn": "sheet-module__aNwnPa__dollWorn",
  "equipmentName": "sheet-module__aNwnPa__equipmentName",
  "equipmentNotes": "sheet-module__aNwnPa__equipmentNotes",
  "equipmentTable": "sheet-module__aNwnPa__equipmentTable",
  "exhaustion": "sheet-module__aNwnPa__exhaustion",
  "expandButton": "sheet-module__aNwnPa__expandButton",
  "expandPlaceholder": "sheet-module__aNwnPa__expandPlaceholder",
  "expandable": "sheet-module__aNwnPa__expandable",
  "experienceButton": "sheet-module__aNwnPa__experienceButton",
  "experienceButtons": "sheet-module__aNwnPa__experienceButtons",
  "experiencePopover": "sheet-module__aNwnPa__experiencePopover",
  "experienceReady": "sheet-module__aNwnPa__experienceReady",
  "expertise": "sheet-module__aNwnPa__expertise",
  "fact": "sheet-module__aNwnPa__fact",
  "facts": "sheet-module__aNwnPa__facts",
  "filterChips": "sheet-module__aNwnPa__filterChips",
  "formRow": "sheet-module__aNwnPa__formRow",
  "formRowControls": "sheet-module__aNwnPa__formRowControls",
  "formRowInput": "sheet-module__aNwnPa__formRowInput",
  "formRows": "sheet-module__aNwnPa__formRows",
  "groupRow": "sheet-module__aNwnPa__groupRow",
  "groupRowContent": "sheet-module__aNwnPa__groupRowContent",
  "groupTitle": "sheet-module__aNwnPa__groupTitle",
  "header": "sheet-module__aNwnPa__header",
  "headerButtons": "sheet-module__aNwnPa__headerButtons",
  "headerSummary": "sheet-module__aNwnPa__headerSummary",
  "headerTitle": "sheet-module__aNwnPa__headerTitle",
  "healthCard": "sheet-module__aNwnPa__healthCard",
  "healthStat": "sheet-module__aNwnPa__healthStat",
  "healthStats": "sheet-module__aNwnPa__healthStats",
  "hitDice": "sheet-module__aNwnPa__hitDice",
  "hitDie": "sheet-module__aNwnPa__hitDie",
  "hitPointsButton": "sheet-module__aNwnPa__hitPointsButton",
  "hitPointsControls": "sheet-module__aNwnPa__hitPointsControls",
  "hitPointsControlsVertical": "sheet-module__aNwnPa__hitPointsControlsVertical",
  "hitPointsCurrent": "sheet-module__aNwnPa__hitPointsCurrent",
  "hitPointsMax": "sheet-module__aNwnPa__hitPointsMax",
  "hitPointsModalQuick": "sheet-module__aNwnPa__hitPointsModalQuick",
  "inactiveIcon": "sheet-module__aNwnPa__inactiveIcon",
  "inlineCheck": "sheet-module__aNwnPa__inlineCheck",
  "journal": "sheet-module__aNwnPa__journal",
  "journalEntry": "sheet-module__aNwnPa__journalEntry",
  "journalTime": "sheet-module__aNwnPa__journalTime",
  "journalTitle": "sheet-module__aNwnPa__journalTitle",
  "journalTotal": "sheet-module__aNwnPa__journalTotal",
  "levelSlot": "sheet-module__aNwnPa__levelSlot",
  "levelSlots": "sheet-module__aNwnPa__levelSlots",
  "levelUpClass": "sheet-module__aNwnPa__levelUpClass",
  "levelUpClasses": "sheet-module__aNwnPa__levelUpClasses",
  "levelUpHitPoints": "sheet-module__aNwnPa__levelUpHitPoints",
  "levelUpSpells": "sheet-module__aNwnPa__levelUpSpells",
  "mark": "sheet-module__aNwnPa__mark",
  "markDanger": "sheet-module__aNwnPa__markDanger",
  "markFilled": "sheet-module__aNwnPa__markFilled",
  "markPlaceholder": "sheet-module__aNwnPa__markPlaceholder",
  "markSmall": "sheet-module__aNwnPa__markSmall",
  "markSquare": "sheet-module__aNwnPa__markSquare",
  "markStatic": "sheet-module__aNwnPa__markStatic",
  "marks": "sheet-module__aNwnPa__marks",
  "measure": "sheet-module__aNwnPa__measure",
  "measureUnit": "sheet-module__aNwnPa__measureUnit",
  "modalButtons": "sheet-module__aNwnPa__modalButtons",
  "muted": "sheet-module__aNwnPa__muted",
  "nameCell": "sheet-module__aNwnPa__nameCell",
  "nameCellContent": "sheet-module__aNwnPa__nameCellContent",
  "nameInput": "sheet-module__aNwnPa__nameInput",
  "narrowLayout": "sheet-module__aNwnPa__narrowLayout",
  "notPrepared": "sheet-module__aNwnPa__notPrepared",
  "notesCell": "sheet-module__aNwnPa__notesCell",
  "nowrap": "sheet-module__aNwnPa__nowrap",
  "origin": "sheet-module__aNwnPa__origin",
  "originTitle": "sheet-module__aNwnPa__originTitle",
  "overridden": "sheet-module__aNwnPa__overridden",
  "paperDoll": "sheet-module__aNwnPa__paperDoll",
  "proficiencyMark": "sheet-module__aNwnPa__proficiencyMark",
  "proficient": "sheet-module__aNwnPa__proficient",
  "quantityInput": "sheet-module__aNwnPa__quantityInput",
  "rechargeNote": "sheet-module__aNwnPa__rechargeNote",
  "restArticle": "sheet-module__aNwnPa__restArticle",
  "restChoice": "sheet-module__aNwnPa__restChoice",
  "restChoiceTitle": "sheet-module__aNwnPa__restChoiceTitle",
  "rightColumn": "sheet-module__aNwnPa__rightColumn",
  "rollAdvantage": "sheet-module__aNwnPa__rollAdvantage",
  "rollButton": "sheet-module__aNwnPa__rollButton",
  "rollDisadvantage": "sheet-module__aNwnPa__rollDisadvantage",
  "rollMenuTitle": "sheet-module__aNwnPa__rollMenuTitle",
  "rollMenuWarning": "sheet-module__aNwnPa__rollMenuWarning",
  "rollSquare": "sheet-module__aNwnPa__rollSquare",
  "row": "sheet-module__aNwnPa__row",
  "rowAside": "sheet-module__aNwnPa__rowAside",
  "rowDescription": "sheet-module__aNwnPa__rowDescription",
  "rowDetails": "sheet-module__aNwnPa__rowDetails",
  "rowLead": "sheet-module__aNwnPa__rowLead",
  "rowMain": "sheet-module__aNwnPa__rowMain",
  "rowText": "sheet-module__aNwnPa__rowText",
  "rowTitle": "sheet-module__aNwnPa__rowTitle",
  "rows": "sheet-module__aNwnPa__rows",
  "screen": "sheet-module__aNwnPa__screen",
  "sheet": "sheet-module__aNwnPa__sheet",
  "slot": "sheet-module__aNwnPa__slot",
  "slotTitle": "sheet-module__aNwnPa__slotTitle",
  "slots": "sheet-module__aNwnPa__slots",
  "spell": "sheet-module__aNwnPa__spell",
  "spellActions": "sheet-module__aNwnPa__spellActions",
  "spellBody": "sheet-module__aNwnPa__spellBody",
  "spellDescription": "sheet-module__aNwnPa__spellDescription",
  "spellList": "sheet-module__aNwnPa__spellList",
  "spellManagement": "sheet-module__aNwnPa__spellManagement",
  "spellManagementHeader": "sheet-module__aNwnPa__spellManagementHeader",
  "spellMark": "sheet-module__aNwnPa__spellMark",
  "spellName": "sheet-module__aNwnPa__spellName",
  "spellRow": "sheet-module__aNwnPa__spellRow",
  "spellbookAddSearch": "sheet-module__aNwnPa__spellbookAddSearch",
  "spellcastingStats": "sheet-module__aNwnPa__spellcastingStats",
  "spellsTable": "sheet-module__aNwnPa__spellsTable",
  "standardActions": "sheet-module__aNwnPa__standardActions",
  "stat": "sheet-module__aNwnPa__stat",
  "statAccent": "sheet-module__aNwnPa__statAccent",
  "statButton": "sheet-module__aNwnPa__statButton",
  "statDanger": "sheet-module__aNwnPa__statDanger",
  "statDrop": "sheet-module__aNwnPa__statDrop",
  "statLabel": "sheet-module__aNwnPa__statLabel",
  "statMenu": "sheet-module__aNwnPa__statMenu",
  "statMenuHeader": "sheet-module__aNwnPa__statMenuHeader",
  "statRoll": "sheet-module__aNwnPa__statRoll",
  "statText": "sheet-module__aNwnPa__statText",
  "statValue": "sheet-module__aNwnPa__statValue",
  "stats": "sheet-module__aNwnPa__stats",
  "statsContainer": "sheet-module__aNwnPa__statsContainer",
  "stepper": "sheet-module__aNwnPa__stepper",
  "stringList": "sheet-module__aNwnPa__stringList",
  "stringListRow": "sheet-module__aNwnPa__stringListRow",
  "summaryStrip": "sheet-module__aNwnPa__summaryStrip",
  "tabBadge": "sheet-module__aNwnPa__tabBadge",
  "tabSection": "sheet-module__aNwnPa__tabSection",
  "tabToolbar": "sheet-module__aNwnPa__tabToolbar",
  "tableNarrowOnly": "sheet-module__aNwnPa__tableNarrowOnly",
  "tableScroll": "sheet-module__aNwnPa__tableScroll",
  "tableWideOnly": "sheet-module__aNwnPa__tableWideOnly",
  "tabs": "sheet-module__aNwnPa__tabs",
  "temporaryPopover": "sheet-module__aNwnPa__temporaryPopover",
  "titleIcons": "sheet-module__aNwnPa__titleIcons",
  "toolbarButtons": "sheet-module__aNwnPa__toolbarButtons",
  "usageTracker": "sheet-module__aNwnPa__usageTracker",
  "visuallyHidden": "sheet-module__aNwnPa__visuallyHidden",
  "weightBar": "sheet-module__aNwnPa__weightBar",
  "weightButton": "sheet-module__aNwnPa__weightButton",
  "weightCaution": "sheet-module__aNwnPa__weightCaution",
  "weightStats": "sheet-module__aNwnPa__weightStats",
  "wrapHeader": "sheet-module__aNwnPa__wrapHeader",
});
